var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"small":"","outlined":""},on:{"click":_vm.forceReload}},[_vm._v("Reload")])
}
var staticRenderFns = []

export { render, staticRenderFns }